import React, { useState } from 'react';
import { MultiSelect } from '../ui/MultiSelect';
import { Input } from '../ui/Input';
export function PenaltiesTab() {
  const [selectedPenalties, setSelectedPenalties] = useState<string[]>([]);
  const [gracePeriodDays, setGracePeriodDays] = useState('');
  return <div className="space-y-6 max-w-4xl animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-853">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-854">
        <div className="md:col-span-2" data-id="element-855">
          <MultiSelect label="Penalty Types (Optional)" value={selectedPenalties} onChange={setSelectedPenalties} placeholder="Select one or multiple penalty types..." options={[{
          value: 'late_payment',
          label: 'Late Payment Penalty'
        }, {
          value: 'default',
          label: 'Default Penalty'
        }, {
          value: 'bounce',
          label: 'Bounce Charge'
        }, {
          value: 'prepayment',
          label: 'Prepayment Penalty'
        }, {
          value: 'overdue',
          label: 'Overdue Interest'
        }]} data-id="element-856" />
        </div>

        <Input type="number" label="Days Before First Penalty" placeholder="e.g., 3" value={gracePeriodDays} onChange={e => setGracePeriodDays(e.target.value)} min="0" data-id="element-857" />
      </div>

      <div className="bg-blue-50 p-4 rounded-md border border-blue-100" data-id="element-858">
        <h4 className="text-sm font-semibold text-blue-800 mb-2" data-id="element-859">
          Grace Period Information
        </h4>
        <p className="text-sm text-blue-600" data-id="element-860">
          <strong data-id="element-861">Days Before First Penalty:</strong> Grace period before the
          first penalty is applied. For example, if set to 3 days, penalties
          will only be charged after 3 days past the due date.
        </p>
      </div>

      <div className="bg-red-50 p-4 rounded-md border border-red-100" data-id="element-862">
        <h4 className="text-sm font-semibold text-red-800 mb-2" data-id="element-863">
          Penalty Configuration
        </h4>
        <p className="text-sm text-red-600" data-id="element-864">
          Select the penalty types that apply to this loan product. Penalties
          are optional and can be configured based on product requirements.
        </p>
      </div>
    </div>;
}